__turbopack_context__.v({
  "ping": "ScrollToTop-module__bPaVnG__ping",
  "sonar-ping": "ScrollToTop-module__bPaVnG__sonar-ping",
  "sonar-squish": "ScrollToTop-module__bPaVnG__sonar-squish",
  "squish": "ScrollToTop-module__bPaVnG__squish",
});
